var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMentor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 104,
    viewBox: "0 0 130 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2503 71.5C41.7649 71.5 41.2794 71.5711 40.8163 71.7214C38.1838 72.5766 35.4152 73.125 32.5003 73.125C29.5855 73.125 26.8169 72.5766 24.1824 71.7214C23.7192 71.5711 23.2358 71.5 22.7503 71.5C10.1444 71.5 -0.0667031 81.7538 0.000328144 94.3759C0.0287656 99.71 4.41423 104 9.75033 104H55.2503C60.5864 104 64.9719 99.71 65.0003 94.3759C65.0674 81.7538 54.8563 71.5 42.2503 71.5ZM32.5003 65C43.27 65 52.0003 56.2697 52.0003 45.5C52.0003 34.7303 43.27 26 32.5003 26C21.7306 26 13.0003 34.7303 13.0003 45.5C13.0003 56.2697 21.7306 65 32.5003 65ZM120.25 0H42.2503C36.8736 0 32.5003 4.51953 32.5003 10.073V19.5C37.2575 19.5 41.6613 20.8772 45.5003 23.1156V13H117V71.5H104V58.5H78.0003V71.5H62.5141C66.3938 74.8902 69.2416 79.367 70.5761 84.5H120.25C125.627 84.5 130 79.9805 130 74.427V10.073C130 4.51953 125.627 0 120.25 0Z",
    fill: "#498CCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentor);
export default __webpack_public_path__ + "static/media/Mentor.e35aaba28ea096476afa51ee948b408d.svg";
export { ForwardRef as ReactComponent };